import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { es } from "date-fns/locale";
import { TextField } from "@mui/material";
import styled from "styled-components";
import { Controller } from "react-hook-form";
import { useState } from "react";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  width: 100%;
  @media only screen and (max-width: 768px) {
    max-width: 100% !important;
  }
`;

const StyledLabel = styled.label`
  font-weight: 600;
  color: var(--header-text);
`;

const ErrorMessage = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: red;
  height: ${(props) => props.error};
  transition: 300ms;
`;

export const InputDatePicker = ({
  name,
  label,
  control,
  errorMessage,
  required = true,
  readOnly = false,
  value,
  ...other
}) => {
  const [reqDate, setreqDate] = useState(null);
  function setDate(e) {
    if ((e) => "Invalid Date") {
      setreqDate(null);
    }
    setreqDate(e);
  }

  return (
    <Container>
      <StyledLabel>{label}</StyledLabel>
      <Controller
        name={name}
        defaultValue={reqDate}
        control={control}
        render={({ field: { onChange, ...restField } }) => (
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
            <DatePicker
              onChange={(event) => {
                onChange(event);
                setDate(event);
              }}
              
              readOnly={readOnly}
              renderInput={(params) => (
                <TextField 
                  type="text"
                  disabled
                  {...params}
                  size="small"
                  inputProps={{
                    ...params.inputProps,
                    placeholder: value || "00/00/0000",
                    readOnly: true,
                  }}
                />
              )}
              {...restField}
            />
          </LocalizationProvider>
        )}
        rules={{ required, minLength: 6 }}
      />
      <ErrorMessage>
        {errorMessage === "required" ? "Campo obligatorio" : ""}
        {errorMessage === "minLength" ? "Ingresa una fecha valida" : ""}
      </ErrorMessage>
    </Container>
  );
};
